import loadable from '@loadable/component';

export const CreateEventPageLoadable = loadable(
  () => import('./CreateEventPage'),
  {
    resolveComponent: (module) => module.CreateEventPage,
    ssr: false,
  },
);
